import * as React from 'react';

import StateStatistics from '../state-statistics/StateStatistics';
import StateStatisticsSidePanel from '../state-statistics-side-panel/StateStatisticsSidePanel';

import { PARTICIPANT_TYPE_TO_STATE_MAP } from 'utils/campaignParticipants';

import './state-statistics-section.scss';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

type Props = {
  campaignId: number,
  channel: string,
  selectedParticipantsType: string,
  isLoadingStatistics: boolean,
  onChannelChange: (a: 'instagram' | 'tiktok') => void,
  onClose: () => void
};

const StatisticsSection = (
  {
    campaignId,
    channel,
    selectedParticipantsType,
    isLoadingStatistics,
    onChannelChange,
    onClose
  }: Props
): JSX.Element => (
  <div className="state-statistics-section">
    <div className="state-statistics-section__header">
      <div className="state-statistics-section__title">
        Statistics
      </div>
      <div className="state-statistics-section__close-action">
        <SVGDynamicIcon
          name="cross-custom-fg"
          customColor="grey"
          width={12}
          height={12}
          onClick={onClose}
        />
      </div>
    </div>
    <div className="state-statistics-section__content">
      <StateStatisticsSidePanel
        channel={channel}
        participantsType={selectedParticipantsType}
        isLoadingStatistics={isLoadingStatistics}
      />
      <div className="state-statistics-section__main-stats">
        <StateStatistics
          campaignId={campaignId}
          offerState={PARTICIPANT_TYPE_TO_STATE_MAP[selectedParticipantsType].state}
          channel={channel}
          onChannelChange={onChannelChange}
        />
      </div>
    </div>
  </div>
);

export default StatisticsSection;
